import { render, staticRenderFns } from "./CustomDashboard.vue?vue&type=template&id=3f4a1564&scoped=true&"
import script from "./CustomDashboard.vue?vue&type=script&lang=ts&"
export * from "./CustomDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4a1564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3f4a1564', component.options)
    } else {
      api.reload('3f4a1564', component.options)
    }
    module.hot.accept("./CustomDashboard.vue?vue&type=template&id=3f4a1564&scoped=true&", function () {
      api.rerender('3f4a1564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/ControlConfiguracion/Configuraciones/CustomDashboard.vue"
export default component.exports